import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LocationSearchContainer from '../LocationSearchContainer';
import CuisinePageHero from '../../components/CuisinePageHero';
import { isSingleCityMarketSelector } from '../../selectors/cuisineSelectors';
import i18n from '../../utils/i18n';
import { urlWithLocale } from '../../utils/locale';
import capitalizeWords from '../../utils/capitalizeWords';

export function CuisinePageHeroContainer({
  isPostcodeSearch,
  cuisineName,
  capitalizedCuisineName,
  cuisineSlug,
  city,
  title,
  description,
  image,
  currentCountry,
  locale,
  isSingleCityMarket,
}) {
  const locationSearch = (
    <LocationSearchContainer
      caption={i18n.gettext(
        `landingPage.cuisine.locationSearch.input.${
          isPostcodeSearch ? 'postcode' : 'formattedAddress'
        }.label(%(cuisine)s)`,
        { cuisine: cuisineName },
      )}
      searchType="restaurants"
      searchFilter={{
        tags: cuisineName.toLowerCase(),
      }}
      trackingPage="Cuisine Landing Page"
      isModal={false}
    />
  );

  const localisedHomePath = urlWithLocale(currentCountry, '/', locale);
  const localisedCuisinePath = `${localisedHomePath}cuisines`;

  let breadcrumbs = [
    {
      href: localisedHomePath,
      label: i18n.gettext('landingPage.cuisine.hero.breadcrumbs.home'),
    },
    {
      href: localisedCuisinePath,
      label: i18n.gettext('landingPage.cuisine.hero.breadcrumbs.cuisine'),
    },
  ];

  if (city) {
    breadcrumbs = [
      ...breadcrumbs,
      {
        href: !isSingleCityMarket ? `${localisedCuisinePath}/${cuisineSlug}` : undefined,
        label: capitalizedCuisineName,
      },
      {
        label: city,
      },
    ];
  } else {
    breadcrumbs = [
      ...breadcrumbs,
      {
        label: capitalizedCuisineName,
      },
    ];
  }

  return (
    <CuisinePageHero
      heading={title}
      description={description}
      locationSearch={locationSearch}
      image={image}
      breadcrumbs={breadcrumbs}
    />
  );
}

CuisinePageHeroContainer.propTypes = {
  isPostcodeSearch: PropTypes.bool.isRequired,
  cuisineName: PropTypes.string.isRequired,
  capitalizedCuisineName: PropTypes.string.isRequired,
  cuisineSlug: PropTypes.string.isRequired,
  city: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  currentCountry: PropTypes.shape({
    postcodeSearch: PropTypes.bool.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  isSingleCityMarket: PropTypes.bool.isRequired,
};

CuisinePageHeroContainer.defaultProps = {
  city: undefined,
};

const mapStateToProps = (state) => {
  const { country: currentCountry, locale } = state.request;
  const { postcodeSearch: isPostcodeSearch } = currentCountry;

  const {
    cuisine: cuisineName,
    slug: cuisineSlug,
    city,
    title,
    description,
    image,
  } = state.cuisine;

  return {
    isPostcodeSearch,
    cuisineName,
    capitalizedCuisineName: capitalizeWords(cuisineName),
    cuisineSlug,
    city,
    title,
    description,
    image,
    currentCountry,
    locale,
    isSingleCityMarket: isSingleCityMarketSelector(state),
  };
};

export default connect(mapStateToProps)(CuisinePageHeroContainer);
